import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DriverInformationListService {

  private selectedDriverSubject = new Subject<any | null>();
  private driversSubject = new Subject<any | null>();

  private refreshListSubject = new Subject<void>();
  public refreshList$ = this.refreshListSubject.asObservable();

  private searchTermSubject = new Subject<string>();
  public searchTerm$ = this.searchTermSubject.asObservable();

  selectedDriver$: Observable<any> = this.selectedDriverSubject.asObservable();
  drivers$: Observable<any> = this.driversSubject.asObservable();

  constructor() { }

  public updateSelectedDriver(driver:any) {
    this.selectedDriverSubject.next(driver);
  }

  public updateDrivers(drivers:any) {
    this.driversSubject.next(drivers)
  }

  public refreshDriverList() {
    this.refreshListSubject.next();
  }

  public updateSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }
}
